<script>
  import { FormGroup, Button, Card, Form, Input, InputGroup, InputGroupAddon, InputGroupText } from "sveltestrap";

  export let rec;
  export let settings;

  import {saveObj} from './recs';
  import { global, UI_ML_EXPLAIN } from "./state";

  const sources = [
    { value: "singleExact", label: "Single column, exact (eg ID / Invoice)"},
    { value: "multipleExact", label: "Multi column (eg Customer and Date)"},
    { value: "floatTolerance", label: "Monetary with tolerance (eg amount +- £0.05)"},
    { value: "custom", label: "Custom rule"},
  ];

  let dsType = 'singleExact';

  window.rec = rec;

  // console.log({rec})
  // console.log({settings})

  let configString = JSON.stringify(rec.config)
  let parseError = false;
  function jsonChanged(e) {
    console.log("json",e.srcElement.value);
    try {
      rec.config = JSON.parse(e.srcElement.value);
      parseError = false;
      console.log("json OK", rec.config)
    } catch(ex) {
      parseError = true;
      console.log("json err")
    }
  }

  let nameCmp = (x,y) => x.name.localeCompare(y.name);
  let aCols = []
  let bCols = []

  let configColTypes   = false;
  let configColAliases = false;
  let configColRules   = true;
  let configColRange   = true;
  let configColHide    = true;
  let configColFormat  = false;
  let configColExplain = false;

  $: {
     aCols = rec.a.columns.sort(nameCmp)
     bCols = rec.b.columns.sort(nameCmp)
  }

  function initConfig(rec) {
    // rec.config ||= {};

    return rec;
  }

  $: {
    if (!rec.config || !rec.config.columns) {
      // rec = initConfig(rec);
      console.log("rec w/o config -----------------------")
    }
    if (rec && rec.config) {
      let tmpConfigString = JSON.stringify(rec.config);
      if (tmpConfigString != configString) {
        configString = JSON.stringify(rec.config, null, 2);
      }
    }
    rec=rec;
  }

  function save(ev) {
    ev.preventDefault(); // needed if inside form...
    try {
      console.log("saveObj saving", rec)
      saveObj(rec);
      console.log("saveObj done")
    } catch(ex) {
      console.log("saveObj ex",ex)
    }
  }

  function doHideAll(e) {
    console.log('doHideAll',e.srcElement.checked);
    rec.config.columns.forEach(col => { col.hide = e.srcElement.checked });
    rec = rec;
  }

  $: {
    // console.log(configColAliases, configColFormat, configColHide, configColRange, configColRules, configColTypes)
  }

</script>
<style>
  .configsection { display: inline-block; }
  .collist { display: inline-block ; vertical-align: top; border: 1px solid grey; border-radius: 0.5rem; padding: 0.5rem;}
  .collist span { padding: 0.25rem;}
  .colside { font-weight: normal;  display: inline-block; width: 6rem;  color: #ccc; }
  .coltype { font-weight: normal;  display: inline-block; width: 6rem;  color: #999; }
  .colname { font-weight: normal;  display: inline-block; width: 12rem;  }
  .colrange { font-weight: normal;  display: inline-block; width: 20rem;  overflow-x: hidden;}
  .colother { font-weight: normal; display: inline-block; width: 14rem;  }
  .colrow { border: 1px solid #ccc; }
  .colrule { display: inline-block; width: 18rem; }
  .colrule input { display: inline-block; width: 10rem; }
  .colhide { display: inline-block; width: 18rem; }

  .collist.a { margin-right: 2rem; }
  .collist.a .colname { text-align: right; }
  .error, .error:focus { color : #ff4040 }

  .key { color: #999; }

  .sources .card {
    display: inline-block;
  }

  .hide { display: none}

  .showconfig {
    margin-left: 3rem;
    color: #999;
  }

  .frag {
    white-space: pre;
  }

  .rulefield { 
    display: inline-block;
    width: 8rem;
    text-align: right;
  }
  .rulevalue {
    display: inline-block;
    background-color: var(--side-b2);
  }

  .rulefield, .rulevalue {
    vertical-align: top;
    margin: 0.5rem;
  }
</style>


<div class="row">
  <div class="form-group col-sm">
    <div class="configsection col">

      <FormGroup>
        <label for="fname">Sources:</label>
        <div class="sources">
          {#each [rec.a, rec.b] as ds}
          <!-- <div class=""> -->
              <Card body>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>Source:</InputGroupText>
                  </InputGroupAddon>
                  <Input bind:value={ds.name} readonly />
                </InputGroup>

                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>Data version:</InputGroupText>
                  </InputGroupAddon>
                  <Input bind:value={ds.stamp} readonly />
                </InputGroup>
              </Card>
          <!-- </div> -->
          {/each}
        </div>
      </FormGroup>

      <FormGroup>
      <label for="fname">Column to link :</label>
      <div>
        <div class="collist a">
          <Input type=select name=a_key selected="{rec.config.a_key}" bind:value={rec.config.a_key}>
            <option value="" >Choose..</option>
          {#each aCols as col}
            <option value="{col.name}" >{col.name}</option>
          {/each}
          </Input>
        </div>
        <div class="collist b">
          <Input type=select name=b_key selected="{rec.config.b_key}" bind:value={rec.config.b_key}>
            <option value="" >Chose..</option>
          {#each bCols as col}
            <option value="{col.name}" >{col.name}</option>
          {/each}
          </Input>
        </div>
      </div>
      </FormGroup>
      <FormGroup>
      <label for="fname">Value columns:</label>
        <div class="collist col">
            <div class="colrow">
              <span class=''>
                Hide all: <input type=checkbox on:change={doHideAll}>
              </span>
              <span class="showconfig">Show config for:</span>
              <span class=''>
                Types: <input type=checkbox bind:checked={configColTypes}>
              </span>
              <span class=''>
                Aliases: <input type=checkbox bind:checked={configColAliases}>
              </span>
              <span class=''>
                Rules: <input type=checkbox bind:checked={configColRules}>
              </span>
              <span class=''>
                Range: <input type=checkbox bind:checked={configColRange}>
              </span>
              <span class=''>
                Hide: <input type=checkbox bind:checked={configColHide}>
              </span>
              <span class=''>
                Format: <input type=checkbox bind:checked={configColFormat}>
              </span>
              {#if global.env.flags[UI_ML_EXPLAIN]}
              <span class=''>
                Auto-rule: <input type=checkbox bind:checked={configColExplain}>
              </span>
              {/if}
            </div>
            {#each rec.config.columns || [] as col}
            <div class="colrow {col.side.toUpperCase()} {rec.config[col.side+"_key"] == col.name ? "key " : ""} ">
              <span class="colname">{col.name}</span>
              <span class="coltype  {configColTypes?'':"hide"}">{col.type}</span>
              <span class="colrange  {configColRange?'':"hide"}">{col.text}</span>
              <span class="colother {configColAliases?'':"hide"}"><Input type="text" bind:value={col.alias}></Input></span>
              <span class="colother {configColRules?'':"hide"}">
                {#if (rec.config[col.side+"_key"] != col.name) }
                  {#if (col.side == "a") }
                    <Input type="select" bind:value={col.compareWithCol}>
                      <option value="" >Don't compare</option>
                    {#each rec.config.columns.filter(c=>c.side != col.side) as other}
                      <option value="{other.name}" >{other.name}</option>
                    {/each}
                    </Input>
                  {:else}
                    <Input type="text" disabled value={(rec.config.columns.filter(c => c.side == 'a' && c.compareWithCol == col.name).shift() || {}).name }></Input>
                  {/if}
                {/if}
              </span> 
              <span class="colrule {configColRules?'':"hide"}">
                {#if (col.compareWithCol) }
                  {#if (col.type == "string") }
                    <Input type="text" bind:value={col.rule}></Input>
                  {:else if (col.type == "number") }
                    <span>+/-:</span>
                    <Input type="text" bind:value={col.tolerance}></Input>
                  {/if}
                {/if}
              </span>
              <span class='colhide {configColHide?'':"hide"}'>
              Hide: <input type=checkbox bind:checked={col.hide}>
              </span>
              <span class='colfmt {configColFormat?'':"hide"}'>
                {#if (col.type && col.type.indexOf("datenum") === 0) }
                Format: <input type=text bind:value={col.format}>
                {/if}
                </span>
              </div>
              {#if global.env.flags[UI_ML_EXPLAIN] && col.side == 'b'}
              <span class='colexpl {configColExplain?'':"hide"}'>
                Rule: <div class=explain>
                  {#if col.explain }
                  <div><span class=rulefield>Type:</span><span class=rulevalue>{col.explain.ruletype}</span></div>
                  <div><span class=rulefield>Input cols:</span><span class=rulevalue>{col.explain.detail.cols}</span></div>
                  <div><span class=rulefield>Logic:</span><span class='rulevalue frag'>{col.explain.detail.frag}</span></div>
                  {/if}
                </div>
              </span>
              {/if}
              <!-- Json: {JSON.stringify(col)} -->
          {/each}
        </div>
      </FormGroup>
    </div>
  </div>
</div>

<!--
<div class="form-group col-sm">
  <label for="key">Record matching rule:</label>
  {#each sources as source, i}
      <div class="form-check">
      <input class="form-check-input" type="radio" id={name}_{source.value} name="dsRadio_{name}" value="{source.value}" checked={i==0} bind:group={dsType} >
      <label class="form-check-label" for="{name}_{source.value}">
        {source.label}
      </label>
    </div>
    {/each}
</div> 
-->
<div class="row" >
  <div class="form-group col-12">
    <label for="fname">Advanced settings:</label>
    <textarea id="config" name="config" class="form-control {parseError ? "error" : ""}"  value={configString} on:change={jsonChanged}></textarea>
    <Button on:click={(ev)=>save(ev)}>Save</Button>
  </div>
</div>
